import { MobileOrderEntryModalComponent } from './../mobile-order-entry-modal/mobile-order-entry-modal.component';
import { NgbModal, NgbModalRef, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { OrderOperationType, OrderEntryModal } from "./orderentry.component";
import {OrderEntryContent} from './orderentry-new-layout.component';

export function ShowModalOrderEntry(
    symbol: string,
    price: number,
    modalService: NgbModal,
    operation: OrderOperationType,
    type: string = "", 
    mobileMode = 'desktop',
    openFromScanner?:boolean,
    newLayout?:boolean
    ) {
    const mobile = mobileMode != 'desktop';
    //let component = mobile? MobileOrderEntryModalComponent: OrderEntryModal;

    //if(newLayout)
   // {
     let component = mobile? MobileOrderEntryModalComponent: OrderEntryContent;
   // }
  
   

    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    
    let m: NgbModalRef = modalService.open(component, opt);

    let modal = <OrderEntryModal>m.componentInstance;

   

    if(openFromScanner)
    {
        modal.isOpenFromScanner = true;
    };

    modal.symbol = symbol;
    modal.entryPrice = price;
    modal.operationType = operation;

    if (type == "equity" || type == "crypto" || type == "bonds") {
        modal.quantity = 30;
    }


    return modal;
    // modal.expiryDate = moment.now();
}

export function ShowModalOrderEntry2(modalService: NgbModal,  mobileMode = 'desktop', newLayout?:boolean) {
    const mobile = mobileMode != 'desktop';
    let component = mobile? MobileOrderEntryModalComponent: OrderEntryModal;

    if(newLayout)
    {
         component = mobile? MobileOrderEntryModalComponent: OrderEntryContent;
    }
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);

    return <OrderEntryModal>m.componentInstance;
    // modal.expiryDate = moment.now();
}


export function ShowModalOrderEntryPartialClose(modalService: NgbModal,  mobileMode = 'desktop', newLayout?:boolean) {
    const mobile = mobileMode != 'desktop';
    let component = mobile? MobileOrderEntryModalComponent: OrderEntryModal;

    if(newLayout)
    {
         component = mobile? MobileOrderEntryModalComponent: OrderEntryContent;
    }
    
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);

    return <OrderEntryModal>m.componentInstance;
    // modal.expiryDate = moment.now();
}

